export const API_URL = 'https://isoft-cm.ru/api';
